// @ts-strict-ignore
import { setContext } from "@apollo/client/link/context";

import { getFingerprintHeader } from "@shared/helpers/getFingerprintHeader/getFingerprintHeader";

/**
 * ⚠️ This operation is really slow and should not be run as a link in the Apollo Client.
 * Instead, use getFingerprint() directly in each GQL request that requires it.
 *
 * An apollo link that sets X-FS-CLIENT-FINGERPRINT header which contains
 * the current device fingerprint
 *
 * @deprecated Use getFingerprint() instead and pass it directly into each GQL request it's required
 */
export const fingerprintLink = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...(await getFingerprintHeader()),
    },
  };
});
